import Input from 'components/form/Inputs/Input';
import INTERVIEW_TYPE from 'enums/InterviewTypes';
import { FC } from 'react';
import styled from 'styled-components';
import Interview from 'types/Interview';

const InputContainer = styled.div`
  width: 100%;
`;

type Props = {
  interview: Interview | undefined;
};
const InterviewInfo: FC<Props> = ({ interview }) => {
  return (
    <InputContainer>
      <Input
        type="text"
        label="Type d'entretien"
        value={interview?.type && INTERVIEW_TYPE[interview.type]}
        disabled
      />
    </InputContainer>
  );
};

export default InterviewInfo;
